export default {
  computed: {
    translations() {
      return {
        ...this.$store.getters.translations,
      };
    },
  },
};
